export { default, SkeletonTheme } from 'react-loading-skeleton';
